import { Theme, styled } from '@material-ui/core';

export const StyledSubHeader = styled('div')<
  Theme,
  { sidepanelwidth?: string | number; presentationmode?: boolean }
>(({ theme, sidepanelwidth, presentationmode }) => ({
  backgroundColor: theme.palette.white,
  paddingInline: theme.spacing(2, 3),
  position: 'absolute',
  top: presentationmode ? 0 : theme.config.appbarHeightPx,
  height: theme.config.subHeaderHeightPx,
  left: 0,
  width: '100%',
  '.fullscreen &': {
    top: 0,
  },
  '.side-panel-open &': {
    width: `calc(100dvw - ${sidepanelwidth}px)`,
  },
  'body:has(#banner) &': {
    top: `${theme.config.appbarHeight + theme.config.messageBarHeight}px`,
    [theme.breakpoints.down('xs')]: {
      top: `${theme.config.mobileMessageBarHeight}px`,
    },
  },
  borderBottom: `1px solid ${theme.config.appbarColors.borderColor}`,
}));

export const StyledContent = styled('div')<Theme, { width?: number | string }>(
  ({ theme, width }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: `calc(100dvw - ${width}px)`,
    paddingInline: theme.spacing(0, 3),
    gap: theme.spacing(2),
    '& h2': {
      flex: 1,
      margin: 0,
    },
  })
);
